import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Switch } from '@material-ui/core'

import LanguageContext from "../../../contexts/LanguageContext"
import UserContext from "../../../contexts/UserContext"

import SuperAdminContext from "../../../contexts/SuperAdminContext"


import { TopBar, BottomBar, CenterContainer } from "./FormatsHelpers"

import EditableField from "./EditableField"
import EditableButton from "./EditableButton"

import EditorPopover from "../../ui/Admin/Formations/EditorPopover"

const FormatTexte = ({ actFormation, actIndex, format, setViewPlanCours, viewPlanCours, onlyContent, isEditor, sequenceSubMenu, setSequenceSubMenu }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const { manageFormatResponse, manageSlide } = useContext(UserContext)

  let superAdminContext = null
  if (isEditor) {
    superAdminContext = useContext(SuperAdminContext)
  }


  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      height:onlyContent?"100%":"100vh",
      overflow:"hidden",
      gap:"10px"
    }}>
      { /* EDITOR ADMIN */}
      {isEditor &&
        <EditorPopover
          open={sequenceSubMenu}
        >
          <Box sx={{marginBottom:"2px", fontWeight:"bold"}}>Image</Box>
          <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
            <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
              <Switch
                sx={{marginLeft:"-5px"}}
                checked={format?.image?true:false}
                onChange={(e) => {
                  if (e.target.checked) {
                    superAdminContext?.onSequenceChange(
                      'image',
                      { link: 'https://video.thelab.risinguparis.com/brain.svg', type: 'contain' },
                      superAdminContext?.adminPlayerIndexes
                    )
                  } else {
                    superAdminContext?.onSequenceChange(
                      'image',
                      null,
                      superAdminContext?.adminPlayerIndexes
                    )
                  }
                }}
                size="small"
                color="warning"
              />
              Afficher une image
            </Box>
            {format?.image &&
              <>
                <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                  <Switch
                    sx={{marginLeft:"-5px"}}
                    checked={format?.image?.type === "contain"?false:true}
                    onChange={(e) => {
                      if (e.target.checked) {
                        superAdminContext?.onSequenceChange(
                          'image',
                          { link: format?.image?.link, type: 'cover' },
                          superAdminContext?.adminPlayerIndexes
                        )
                      } else {
                        superAdminContext?.onSequenceChange(
                          'image',
                          { link: format?.image?.link, type: 'contain' },
                          superAdminContext?.adminPlayerIndexes
                        )
                      }
                    }}
                    size="small"
                    color="warning"
                  />
                  Élargir l'image
                </Box>
                <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
                  <Box>
                    Url :
                  </Box>
                  <Box sx={{flex:1}}>
                    <input
                      value={format?.image?.link}
                      style={{width:"100%"}}
                      onChange={(e) => {
                        superAdminContext?.onSequenceChange(
                          'image',
                          { link: e.target.value, type: format?.image?.type },
                          superAdminContext?.adminPlayerIndexes
                        )
                      }}
                    />
                  </Box>
                </Box>
              </>
            }
          </Box>
        </EditorPopover>
      }
      { /* END EDITOR ADMIN */}

      <TopBar
        actFormation={actFormation}
        actIndex={actIndex}
        setViewPlanCours={setViewPlanCours}
        viewPlanCours={viewPlanCours}
        onlyContent={onlyContent}
      />
      <CenterContainer
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={onlyContent}
      >
        <EditableField
          field={format?.title}
          type="title"
          isEditor={isEditor}
          sx={{
            color:"text.black",
            fontSize:["26px", "42px", "42px", "46px"],
            textAlign:"center"
          }}
        />
        <EditableField
          field={format?.subTitle}
          type="subTitle"
          isEditor={isEditor}
          sx={{
            color:"text.subTitle",
            fontSize:["16px", "20px", "20px", "26px"],
            textAlign:"center",
            margin:["10px 0px", "15px 0px", "15px 0px", "20px 0px"]
          }}
        />
        <Box sx={{
          width:"100%",
          maxHeight:["unset", "unset", "unset", "calc(100vh - 260px)"],
          display:"flex",
          flexDirection:["column", "column", "column", "row"],
          gap:["20px", "40px", "40px", "60px"],
          overflow:["unset", "unset", "unset", "hidden"],
          marginTop:"15px",
          marginBottom:"15px",
        }}>
          {format?.image &&
            <Box sx={{
              flex: ["unset", "unset", "unset", 0.4],
            }}>
              <Box sx={{
                background:"white",
                width:"100%",
                border:"1px solid black",
                height:["250px", "400px", "400px", "unset"],
                aspectRatio:["unset", "unset", "unset", "520/450"],
                backgroundRepeat:"no-repeat",
                backgroundPosition:"center center",
                backgroundImage:"url("+format?.image?.link+")",
                backgroundSize:format?.image?.type === "cover" ? "cover" : "contain",
              }}>
              </Box>
            </Box>
          }
          <Box sx={{
            flex:format?.image ? ["unset", "unset", "unset", 0.6] : ["unset", "unset", "unset", 1],
            overflowX:"hidden",
            overflowY:["hidden", "hidden", "hidden", "auto"],
            display:"flex",
            flexDirection:"column",
          }}>
            <Box sx={{
              //margin:["10px 0px", "15px 0px", "15px 0px", "20px 0px"],
              background:"#FAF8F7",
              border:"1px solid #D4D4D4",
              padding:["15px 10px", "20px 13px", "20px 13px", "30px 15px"],
              maxWidth:"800px",
              marginLeft:"auto",
              marginRight:"auto"
            }}>
              <EditableField
                field={format?.text}
                type="text"
                isEditor={isEditor}
                sx={{
                  color:"text.black",
                  fontSize:["14px", "18px", "18px", "20px"],
                  textAlign:"justify",
                  //textAlignLast:"justify",
                }}
              />
            </Box>
          </Box>
        </Box>
        {/*
        <Box sx={{
          display:"flex",
          flexDirection:["column", "column", "row", "row"],
          justifyContent:"center",
          alignItems:"center",
          width:"100%",
        }}>
          <Box sx={{
            flex:format?.image ? 0.5 : 1,
            margin:["10px 0px", "15px 0px", "15px 0px", "20px 0px"],
            background:"#FAF8F7",
            border:"1px solid #D4D4D4",
            padding:["15px 10px", "20px 13px", "20px 13px", "30px 15px"],
            maxWidth:"800px",
          }}>
            <EditableField
              field={format?.text}
              type="text"
              isEditor={isEditor}
              sx={{
                color:"text.black",
                fontSize:["14px", "18px", "18px", "20px"],
                textAlign:"center",
              }}
            />
          </Box>
          {format?.image &&
            <Box sx={{
              flex:0.5,
              padding:["15px 10px", "20px 13px", "20px 13px", "30px 15px"],
              display:"flex",
              justifyContent:"center",
              alignItems:"center",
            }}>
              {format?.image?.type === "contain" &&
                <img src={format?.image?.link} style={{ height:"100%", maxWidth:"100%" }}/>
              }
              {format?.image?.type === "cover" &&
                <img src={format?.image?.link} style={{ width:"100%", maxWidth:"100%" }}/>
              }
            </Box>
          }
        </Box>
        */}
      </CenterContainer>
      <BottomBar
        actFormation={actFormation}
        actIndex={actIndex}
        onlyContent={isEditor ? false : onlyContent}
        isEditor={isEditor}
        buttons={
          <EditableButton
            isEditor={isEditor}
            type="button"
            field={format?.button?.text}
            sx={{}}
            onClick={() => {
              manageFormatResponse(format, [{ key: 'isDone', value: true }])
              manageSlide(1)
            }}
          />
        }
      />
    </Box>
  )
}


export default FormatTexte
